import React from "react";
import Grid from "@material-ui/core/Grid";
import { graphql, useStaticQuery } from "gatsby";

/* importing custom modules */
import ImageGridList from "../Material-UI-Components/GridList.js";
import ImpactPosts from "../Page-Data/ImpactPosts.json";

const IMAGE_EXTENSION_PATTERN = /\.(jpe?g|png)$/i;

export default function CustomImpact() {
    const data = useStaticQuery(graphql`
        query ImpactGalleryImages {
            allFile(
                filter: { relativeDirectory: { eq: "Impact" } }
                sort: { fields: name, order: ASC }
            ) {
                nodes {
                    name
                    publicURL
                    relativePath
                }
            }
        }
    `);

    const impactImages = (data?.allFile?.nodes || [])
        .filter((node) => IMAGE_EXTENSION_PATTERN.test(node.relativePath))
        .filter((node) => node.name.toLowerCase() !== "logo")
        .map((node) => node.publicURL);

    const dualCarouselBuckets = [[], []];
    impactImages.forEach((imageUrl, index) => {
        dualCarouselBuckets[index % 2].push(imageUrl);
    });

    return (
        <div>
            <div className="grid-container">
                {ImpactPosts &&
                    ImpactPosts.map((index, sectionIndex) => {
                        const sectionImages =
                            dualCarouselBuckets[sectionIndex] || index["imagesLink"] || [];
                        return (
                            <Grid
                                container
                                justify="center"
                                alignItems="center"
                                className="postContainer"
                                key={index["title"]}
                            >
                                <Grid item xs={12} sm={12} md={12} className="container1">
                                    <h2>{index["title"]}</h2>
                                    <div className="postDescription">{index["description"]}</div>
                                    <div className="publishedDate publishedDateImpact">
                                        Published Date: {index["publishedDate"]}
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    {sectionImages.length > 0 ? (
                                        <ImageGridList data={sectionImages} />
                                    ) : (
                                        <></>
                                    )}
                                </Grid>
                            </Grid>
                        );
                    })}
            </div>
        </div>
    );
}